import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";

const getEventData = async (pageNumber, pageSize) => {
  const url = `api/event?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  console.log(url);
  const { data } = await apiClient.get(url);
  console.log(data);
  return data;
};

const useGetEvents = (pageNumber, pageSize) => {
  return useQuery({
    queryKey: "events",
    queryFn: () => getEventData(pageNumber, pageSize),
    staleTime: 1000 * 60 * 60 * 2, // Cache for 2 hours
    cacheTime: 1000 * 60 * 60 * 2, // Keep cache for 2 hours
  });
};

export default useGetEvents;
